<template>
  <div class="container pt-3" v-if="submission">
    <div v-if="this.submitted" class="mb-3">
      <img src="../../assets/complete.png" class="completed-img mr-3">
      <p class="completed-text">This form has been successfully submitted</p>
    </div>
    <h1>Scholarship Review</h1><hr style="height: 4px;">
    <div :class="org">
      <legend><h3>Applicant's Name</h3></legend>
      <p>{{submission.user.first_name}} {{submission.user.last_name}} </p><hr>
      <fieldset v-for="(category, cIndex) in submissionDisplay" v-bind:key="cIndex">
        <h3>{{submission.categories[cIndex].name}}</h3>
        <div v-for="(question, qIndex) in category" v-bind:key="qIndex">
          <div v-if="Array.isArray(question)">
            <QuestionGroupReview :questions="submission.categories[cIndex].questions" :indexes="question"/>
          </div>
          <div v-else>
            <QuestionReview :q="submission.categories[cIndex].questions[question]" />
          </div>
        </div>
        <hr/>
      </fieldset>
    </div>
    <p v-if="this.completed != 100 || this.hasCategoryErrors()" class="text-danger">*You cannot submit until you have fixed all of the errors on the application.</p>
    <p v-if="this.confirmed != true" class="text-danger">*You cannot submit until you have confirmed your account. To resend the confirmation email click <router-link :to="{name: 'resendConfirmation'}">here</router-link>.</p>
    <button v-if="!this.submitted" :disabled="this.completed != 100 || this.confirmed != true" class="mt-4 mr-2 mb-1 p-2 btn btn-primary" @click="submitSubmission">Submit</button>
    <button v-else-if="this.submitted" class="mt-4 mr-2 mb-1 p-2 btn btn-primary" @click="redirectToStatus">Status</button>
    <button class="mt-4 mb-1 p-2 btn bg-grey btn-primary" @click="printMe">Print</button>
  </div>
</template>

<script>
import axios from '../../auth.js'
import '../../assets/print.scss'
import '../../Root.vue'
import QuestionReview from './QuestionReview.vue'
import QuestionGroupReview from './QuestionGroupReview.vue'

export default {
  components: {
    QuestionReview,
    QuestionGroupReview
  },
  data(){
    return {
      status: "",
      submission: null,
      submission_id: null,
      submitted: null,
      org: this.$route.params.organization_name,
      scholarship: this.$route.params.scholarship_name,
      submissionDisplay: [],
      completed: null,
      confirmed: null
    }
  },
  mounted(){
    this.getSubmission()
  },
  methods:{
    formatForDisplay() {
      for (var cat in this.submission.categories) {
        var category = []
        this.submissionDisplay.push(category)
        var counter = 0
        for (var q in this.submission.categories[cat].questions) {
          var question = this.submission.categories[cat].questions[q]
          if (question.repeatable) {
            if (q === '0') {
              this.submissionDisplay[Number(cat)][counter] = []
              this.submissionDisplay[Number(cat)][counter].push(Number(q))
            } else if (Array.isArray(this.submissionDisplay[Number(cat)][counter])) {
              if (question.repeat_group === this.submission.categories[cat].questions[this.submissionDisplay[Number(cat)][counter][0]].repeat_group) {
                //another element of the same repeat group
                this.submissionDisplay[Number(cat)][counter].push(Number(q))
              } else {
                //an element of the next repeat group
                counter++
                this.submissionDisplay[Number(cat)][counter] = []
                this.submissionDisplay[Number(cat)][counter].push(Number(q))
              }
            } else {
              //the first element of a new section
              counter++
              this.submissionDisplay[Number(cat)][counter] = []
              this.submissionDisplay[Number(cat)][counter].push(Number(q))
            }
          } else {
            if (q !== '0') {
              counter++
            }
            this.submissionDisplay[Number(cat)][counter] = Number(q)
          }
        }
      }
    },
    redirectToStatus() {
      this.$router.push({name: "status",
        params: { organization_name: this.$route.params.organization_name,
                  scholarship_name: this.$route.params.scholarship_name}})
    },
    submitSubmission(event) {
      event.preventDefault()
      axios.post(
        `${process.env.VUE_APP_ENDPOINT}/api/applicant/${this.org}/${this.scholarship}/submit/`,
        {}
      ).then( () => {
        this.$toasted.success('The application has been successfully submitted!',
            {
              position: "bottom-right",
              duration: 10000
            })
        this.$router.push({name: "status",
          params: { organization_name: this.$route.params.organization_name,
                    scholarship_name: this.$route.params.scholarship_name}}),
        {
          position: "bottom-right"
        }
      }).catch(err => {
        if(err.response.data.message === "The application has already been submitted.") {
          this.$router.push({name: "status",
            params: { organization_name: this.$route.params.organization_name,
                    scholarship_name: this.$route.params.scholarship_name}})
        } else if(err.response.data.message === "The account submitting this application has not been confirmed yet.") {
          //do nothing
        } else {
          this.$router.push({name: "apply",
            params: { organization_name: this.$route.params.organization_name,
                    scholarship_name: this.$route.params.scholarship_name}})
        }
        this.$toasted.error(
          err.response.data.message,
          {
            theme: "outline",
            position: "bottom-right",
            duration : 10000
          })
      })
    },
    getSubmission() {
      this.status = "Loading..."
      axios.get(
        `${process.env.VUE_APP_ENDPOINT}/api/applicant/${this.org}/${this.scholarship}/`
      ).then(res => {
        this.submission = res.data
        if (!this.submission.user) {
          this.$router.push({name: 'information'})
        }
        this.submission_id = this.submission.id
        this.submitted = this.submission.submitted
        this.status = ""
        this.completed = this.submission.progress.percent_complete
        this.confirmed = this.submission.user.confirmed
        this.formatForDisplay()
      }
      ).catch(e => {
        if (typeof e.response.data.error != "undefined")
          this.message = e.response.data.error
        this.status = "Error"
      })
    },
    printMe() {
      window.print();
    },
    hasCategoryErrors() {
      var hasErrors = false
      for(var category in this.submission.categories){
        if(this.submission.categories[category].error){
          hasErrors = true
        }
      }
      return hasErrors
    }
  },
  beforeRouteLeave (to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    /*
    * to {name: "apply", path:""}, from: {name: "review", path:""}
    */
    if( this.submitted ){
      switch(to.name) {
      case "apply":
        next(from.path)
        this.$toasted.error(
          "The application has already been submitted.",
          {
            theme: "outline",
            position: "bottom-right",
            duration : 10000
          }
        )
        break;
      case "submit":
        next({
          name: "status",
          params: {
            organization_name: this.$route.params.organization_name,
            scholarship_name: this.$route.params.scholarship_name
          }
        })
        this.$toasted.error(
          "The application has already been submitted.",
          {
            theme: "outline",
            position: "bottom-right",
            duration : 10000
          }
        )
        break;
      default:
        next()
      }
    }else{
      next()
    }
  }
}
</script>

<style scoped>

.completed-img {
  height: 2.5em;
  display: inline-block;
}

.completed-text {
  display: inline-block;
  line-height: .5em;
}

button:disabled {
  color: #cfcfcf !important;
  border: 2px solid #cfcfcf;
}

</style>
